import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  BILLS_ADD_BILL_PATH,
  BILLS_CHECK_STATUS_PATH,
  BILLS_PATH,
  BILLS_PUBLIC_ADD_BILL_PATH,
  BILLS_PUBLIC_CHECK_STATUS_PATH,
  BILLS_PUBLIC_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const OutstandingBillPage = lazy(() => import('./pages/OutstandingBillPage/OutstandingBillPage'));
const AddBillPage = lazy(() => import('./pages/AddBillPage/AddBillPage'));
const PaymentStatusPage = lazy(() => import('./pages/PaymentStatusPage/PaymentStatusPage'));

export const BILL_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    actionUrl: ACTION_BACK_PATH,
    component: () => <OutstandingBillPage isSingpass />,
    displayTitle: () => 'Bills & Payments',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: BILLS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.payment,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <OutstandingBillPage />,
    displayTitle: () => 'Bills & Payments',
    isNavHeaderHide: true,
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PUBLIC,
    path: BILLS_PUBLIC_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.publicPayment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <AddBillPage isSingpass />,
    displayTitle: () => 'Add Bill(s)',
    pageType: PageType.PRIVATE,
    path: BILLS_ADD_BILL_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.payment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <AddBillPage />,
    displayTitle: () => 'Add Bill(s)',
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PUBLIC,
    path: BILLS_PUBLIC_ADD_BILL_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.publicPayment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentStatusPage isSingpass />,
    displayTitle: () => 'Bills & Payments',
    isHideBackNavButton: true,
    pageType: PageType.PRIVATE,
    path: BILLS_CHECK_STATUS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.payment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PaymentStatusPage />,
    displayTitle: () => 'Bills & Payments',
    isHideBackNavButton: true,
    layoutProps: {
      contentClassName: 'lg:max-w-5xl',
    },
    pageType: PageType.PUBLIC,
    path: BILLS_PUBLIC_CHECK_STATUS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.publicPayment,
  },
];
